import React, {FC} from 'react'
import {TAG_COLORS} from './TagModel'
import {TagChip} from './TagChips'

type Props = {
  name: string
  color: string
  onNameChange: (name: string) => void
  onColorChange: (color: string) => void
  nameError?: string
  colorError?: string
  autoFocus?: boolean
}

/** Etiket adı + renk seçimi (hazır palet ve serbest renk seçici) ile canlı önizleme */
export const TagFormFields: FC<Props> = ({
  name,
  color,
  onNameChange,
  onColorChange,
  nameError,
  colorError,
  autoFocus,
}) => (
  <>
    <div className='mb-5'>
      <label className='form-label fw-bold required'>Etiket Adı</label>
      <input
        type='text'
        autoFocus={autoFocus}
        maxLength={50}
        className={`form-control ${nameError ? 'is-invalid' : ''}`}
        placeholder='Örn: Güçlü aday, Tekrar görüşülecek'
        value={name}
        onChange={(event) => onNameChange(event.target.value)}
      />
      {nameError && <div className='invalid-feedback'>{nameError}</div>}
    </div>

    <label className='form-label fw-bold required'>Renk</label>
    <div className='d-flex flex-wrap align-items-center gap-2 mb-2'>
      {TAG_COLORS.map((option) => (
        <button
          key={option}
          type='button'
          title={option}
          className='btn p-0 rounded-circle'
          style={{
            width: 28,
            height: 28,
            backgroundColor: option,
            outline: option.toLowerCase() === color.toLowerCase() ? '3px solid #181c32' : 'none',
            outlineOffset: 2,
          }}
          onClick={() => onColorChange(option)}
        />
      ))}
      <input
        type='color'
        className='form-control form-control-color p-1'
        style={{width: 44, height: 32}}
        title='Başka bir renk seç'
        value={/^#[0-9a-fA-F]{6}$/.test(color) ? color : '#009ef7'}
        onChange={(event) => onColorChange(event.target.value)}
      />
    </div>
    {colorError && <div className='text-danger fs-7 mb-2'>{colorError}</div>}

    <div className='d-flex align-items-center gap-3 mt-4'>
      <span className='text-muted fs-7'>Önizleme:</span>
      <TagChip tag={{id: 'preview', name: name.trim() || 'Etiket', color}} small={false} />
    </div>
  </>
)
